import { ApiError } from '@reflex/ui/client/http';

/**
 * Map an email/password API failure to a friendly message shown above the
 * form. Branches on the machine-readable `code` the plugin's server routes
 * emit (`INVALID_CREDENTIALS`, `EMAIL_TAKEN`, `REGISTRATION_DISABLED`,
 * `EMAIL_AUTH_UNAVAILABLE`); anything else falls back to the server message
 * or a generic retry prompt.
 */
export function describeEmailAuthError(err: unknown): string {
  if (err instanceof ApiError) {
    switch (err.code) {
      case 'INVALID_CREDENTIALS':
        return 'Invalid email or password.';
      case 'EMAIL_TAKEN':
        return 'An account with that email already exists. Try signing in instead.';
      case 'REGISTRATION_DISABLED':
        return 'Email registration is disabled. Contact your administrator.';
      case 'EMAIL_AUTH_UNAVAILABLE':
        return 'Email sign-in is temporarily unavailable. Try again shortly.';
      default:
        return err.message || 'Something went wrong. Please try again.';
    }
  }
  return 'Something went wrong. Please try again.';
}
